import { makeStyles, Typography, useTheme } from "@material-ui/core";
import { NextPage } from "next";
import { WAVE, WAVE_DELAY } from "../AppTheme";
import { SignupLayout } from "../layouts/pages/SignupLayout";

const useStyles = makeStyles((theme) => ({
  ...WAVE.keyframes,
  ...WAVE_DELAY.keyframes,
  subtitle: {
    margin: "0 auto",
    padding: theme.spacing(1.75, 0, 3),
    maxWidth: 400,
    [theme.breakpoints.up("sm")]: {
      maxWidth: "none",
    },
  },
  confetti: {
    display: "inline-block",
    fontWeight: theme.typography.fontWeightBold,
    marginLeft: theme.spacing(0.75),
    position: "relative",
    zIndex: 1,
    "&:hover span": {
      ...WAVE.elementStyles,
    },
    "& span": {
      ...WAVE_DELAY.elementStyles,
      display: "inline-block",
    },
    "& span:nth-child(1)": {
      animationDelay: ".3s",
    },
    "& span:nth-child(2)": {
      animationDelay: ".4s",
    },
    "& span:nth-child(3)": {
      animationDelay: ".5s",
    },
    "& span:nth-child(4)": {
      animationDelay: ".6s",
    },
    "& span:nth-child(5)": {
      animationDelay: ".7s",
    },
    "& span:nth-child(6)": {
      animationDelay: ".8s",
    },
    "& span:nth-child(7)": {
      animationDelay: ".9s",
    },
    "& span:nth-child(8)": {
      animationDelay: "1s",
    },
    "& span:nth-child(9)": {
      animationDelay: "1.1s",
    },
  },
}));

const Signup: NextPage = () => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <SignupLayout title="Sign Up" displayLoginButton officeNotice>
      <Typography component="h1" variant="h2">
        Start your free trial
      </Typography>
      <Typography variant="subtitle2" className={classes.subtitle}>
        Reclaim works best with your
        <span className={classes.confetti}>
          <span>w</span>
          <span>o</span>
          <span>r</span>
          <span>k</span>&nbsp;
          <span>e</span>
          <span>m</span>
          <span>a</span>
          <span>i</span>
          <span>l</span>
        </span>
      </Typography>
    </SignupLayout>
  );
};

export default Signup;
